<template lang="pug">
#admin
    Loading
    ChooseBizDialog(v-model="$store.state.account.lastlyUsedBusinessId == null")
    v-app-bar.no-print(clipped-left, app, color="#fae3d8")
        v-app-bar-nav-icon.d-lg-none(@click.stop="drawer = !drawer")
        v-toolbar-title
            a.logo-title(
                @click="$router.push('/'+$i18n.locale+'/dashboard')",
                style=" color:#ffffff"
            )
                v-img(contain src="@/assets/images/logo.png" max-height="45")

        v-spacer

        .bar-menu.d-none.d-lg-block
            v-menu(open-on-hover, offset-y, v-for="(menuitem, i) in menu", :key="i")
                template(v-slot:activator="{ on }")
                    v-btn.menu-title(
                        text,
                        v-on="on",
                        @click="if (menuitem.link) { $router.push(menuitem.link) }",
                    ) 
                        v-icon.primary--text(left, small, v-if="menuitem.icon") {{ menuitem.icon }}
                        .text-capitalize.primary--text {{ $t(menuitem.title) }}
                        v-icon.primary--text(right, small, v-if="menuitem.childs") keyboard_arrow_down
                v-list.pa-0(v-if="menuitem.childs")
                    template(v-for="child in menuitem.childs")
                        v-list-item(:to="child.link")
                            v-list-item-title {{ $t(child.title) }}
                        v-divider
        UserMenu
    v-navigation-drawer(v-model="drawer" app)
        v-list(nav, dense)
            template(v-for="menuitem in menu")
                v-list-group(v-if="menuitem.childs")
                    template(v-slot:activator)
                        v-list-item-title {{ $t(menuitem.title) }}
                    template(v-for="child in menuitem.childs")
                        v-list-item(:to="child.link")
                            v-list-item-title {{ $t(child.title) }}
                        v-divider
                v-list-item(
                    v-else,
                    :to="menuitem.link",
                )
                    v-list-item-title {{ $t(menuitem.title) }}

    v-main
        router-view
</template>

<script>
import Loading from "@/components/globals/Loading"
import UserMenu from "@/components/UserMenu"
import ChooseBizDialog from "@/components/dialogs/ChooseBizDialog"
import NewBizDialog from "@/components/dialogs/NewBizDialog"

export default {
  components: { Loading, UserMenu, ChooseBizDialog, NewBizDialog },
  data() {
    return {
      lang: "",
      drawer: false,
      env: process.env.NODE_ENV,
      menu: [
        {
          title: "Menu.__Dashboard",
          link: "/" + this.$i18n.locale + "/dashboard",
          icon: "fas fa-chart-bar",
          disabled: false
        },
        {
          title: "Menu.__Sales",
          icon: "fas fa-cash-register",
          childs: [
            {
              title: "Menu.__Estimate",
              link: "/" + this.$i18n.locale + "/estimates",
              disabled: false
            },
            {
              title: "Menu.__Invoice",
              link: "/" + this.$i18n.locale + "/invoices",
              disabled: false
            },
            // {
            //     title: "Menu.__CustomerStatement",
            //     link: "/" + this.$i18n.locale + "/statements",
            //     disabled: true
            // },
            {
              title: "Menu.__CustomerInfo",
              link: "/" + this.$i18n.locale + "/customers",
              disabled: false
            },
            {
              title: "Menu.__ProductAndService",
              link: "/" + this.$i18n.locale + "/products/sell",
              disabled: false
            }
          ],
          disabled: false
        },
        {
          title: "Menu.__Purchase",
          icon: "fas fa-file-invoice-dollar",
          disabled: false,
          childs: [
            {
              title: "Menu.__Bill",
              link: "/" + this.$i18n.locale + "/bills",
              disabled: false
            },
            {
              title: "Menu.__Receipt",
              link: "/" + this.$i18n.locale + "/receipts",
              disabled: false
            },
            {
              title: "Menu.__VendorInfo",
              link: "/" + this.$i18n.locale + "/vendors",
              disabled: false
            },
            {
              title: "Menu.__ProductAndService",
              link: "/" + this.$i18n.locale + "/products/buy",
              disabled: false
            }
          ]
        },
        {
          title: "Menu.__Taxes",
          icon: "fas fa-hand-holding-usd",
          link: "/" + this.$i18n.locale + "/taxes",
          disabled: false
        },
        {
          title: "Menu.__Accounting",
          icon: "fas fa-calculator",
          disabled: false,
          childs: [
            {
              title: "Menu.__Transaction",
              link: "/" + this.$i18n.locale + "/accounting/transactions",
              disabled: false
            },
            {
              title: "Menu.__ChartOfAccounts",
              link: "/" + this.$i18n.locale + "/accounting/account-manage",
              disabled: false
            }
          ]
        },
        {
          title: "Menu.__Report",
          icon: "fas fa-th-list",
          link: "/" + this.$i18n.locale + "/reports",
          disabled: false
        }
      ]
    }
  },
  methods: {},
  computed: {},

  created() {}
}
</script>

<style lang="scss" scoped></style>
